import React, { useEffect } from 'react';
import styled, { createGlobalStyle, css } from 'styled-components';
import { DARK_THEME_CLASS } from '../constant';
import { ColorMode } from '../type';
const ROOT_LEVEL_STYLE_CLASS = 'rootLevelLUXStyles';
const GlobalStyles = createGlobalStyle `${({ generalCss, lightModeCss, darkModeCss }) => css `:root{${generalCss} ${lightModeCss}}body.${DARK_THEME_CLASS}{${darkModeCss}}`}`;
const LUXThemeWrapper = styled.div.withConfig({ displayName: "LUXThemeWrapper", componentId: "sc-9kum3v" }) `${({ generalCss, lightModeCss, darkModeCss, colorMode }) => css `${generalCss} ${colorMode === ColorMode.DARK ? darkModeCss : lightModeCss}`}`;
export const TemplateLUXTheme = ({ children, colorMode, injectStylesToRootLevel, generalCss, lightModeCss, darkModeCss, }) => {
    useEffect(() => {
        if ((document === null || document === void 0 ? void 0 : document.body) && injectStylesToRootLevel) {
            if (!document.body.classList.contains(ROOT_LEVEL_STYLE_CLASS))
                document.body.classList.add(ROOT_LEVEL_STYLE_CLASS);
            else {
                throw new Error('More than one root level LUXProvider is available which can override each other styles. Please use single LUXProvider or add "isRootLevel={false}" prop to child provider');
            }
        }
        return () => {
            if (injectStylesToRootLevel) {
                document.body.classList.remove(ROOT_LEVEL_STYLE_CLASS);
            }
        };
    }, []);
    return injectStylesToRootLevel ? (React.createElement(React.Fragment, null,
        React.createElement(GlobalStyles, { generalCss: generalCss, lightModeCss: lightModeCss, darkModeCss: darkModeCss }),
        children)) : (React.createElement(LUXThemeWrapper, { colorMode: colorMode, generalCss: generalCss, lightModeCss: lightModeCss, darkModeCss: darkModeCss }, children));
};
//# sourceMappingURL=template.js.map